import { ethers } from 'ethers'

export function formatUnitToNumber(value) {
  return ethers.utils.formatUnits(value, 0)
}

export function formatUnitToEther(value) {
  return ethers.utils.formatEther(value)
}
